<div
  *ngIf="item"
  class="delete-role-dialog">
  <h2 class="headline">{{'ROLE_PAGE.MODAL.DELETE_ROLE' | translate}}</h2>
  <p class="description">{{'ROLE_PAGE.MODAL.DESCRIPTION_DELETE' | translate}}</p>
  <h3 class="subtitle">{{item.name}}</h3>
  <div class="btn-block">
    <button
      (click)="deleteCurrentRole()"
      class="btn btn-danger">
      {{'ROLE_PAGE.MODAL.DELETE' | translate}}
    </button>
    <button
      (click)="closeModal()"
      class="btn btn-light">
      {{'ROLE_PAGE.MODAL.CANCEL' | translate}}
    </button>
  </div>
</div>
